var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Dialog, Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/solid";
import { AnnotationOutline, CogOutline, CreditCardOutline, ExclamationOutline, HomeOutline, LightningBoltOutline, LogoutOutline, PlusOutline, ShoppingCartOutline, SupportOutline, TableOutline, } from "heroicons-react";
import React, { Fragment, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { USER_LOGOUT } from "../../actions";
import LogoLight from "../../assets/img/logo-light.svg";
import { MenuItem, Plan, Redirect, RedirectSubdomain } from "@domainpage/shared/src";
import AuthContext from "../../context/AuthContext";
import AppLink from "../AppLink";
var Sidebar = function (_a) {
    var sidebarOpen = _a.sidebarOpen, sidebarOpenCallback = _a.sidebarOpenCallback;
    var history = useHistory();
    var _b = useContext(AuthContext), auth = _b.state, dispatch = _b.dispatch;
    var _c = auth.user, planType = _c.planType, planInterval = _c.planInterval;
    var userOnFreePlan = planType === Plan.PLAN_ONE;
    var mainMenuItems = [
        {
            title: MenuItem.DOMAINS,
            link: Redirect.DASHBOARD,
            icon: _jsx(HomeOutline, { className: "mr-4 h-6 w-6 text-white" }, void 0),
            active: false,
        },
        {
            title: MenuItem.ADD_DOMAIN,
            link: Redirect.DOMAINS_NEW,
            icon: _jsx(PlusOutline, { className: "mr-4 h-6 w-6 text-white" }, void 0),
            active: false,
        },
        // {
        //     title: MenuItem.SALES,
        //     link: Redirect.SALES,
        //     icon: <ChartBarOutline className={"mr-4 h-6 w-6 text-white"} />,
        //     active: false,
        // },
        {
            title: MenuItem.LEADS,
            link: Redirect.LEADS,
            icon: _jsx(AnnotationOutline, { className: "mr-4 h-6 w-6 text-white" }, void 0),
            active: false,
        },
        {
            title: MenuItem.EXPIRATIONS,
            link: Redirect.EXPIRATIONS,
            icon: _jsx(ExclamationOutline, { className: "mr-4 h-6 w-6 text-white" }, void 0),
            active: false,
        },
        {
            title: MenuItem.BULK_IMPORT_EXPORT,
            link: Redirect.BULK_IMPORT_EXPORT,
            icon: _jsx(TableOutline, { className: "mr-4 h-6 w-6 text-white" }, void 0),
            active: false,
        },
        {
            title: MenuItem.MARKETPLACE,
            link: "https://shop.".concat(process.env.REACT_APP_ROOT_URL),
            icon: _jsx(ShoppingCartOutline, { className: "mr-4 h-6 w-6 text-white" }, void 0),
            active: false,
            external: true,
        },
    ];
    if (userOnFreePlan) {
        mainMenuItems.push({
            title: MenuItem.UPGRADE_ACCOUNT,
            link: Redirect.BILLING,
            icon: _jsx(LightningBoltOutline, { className: "mr-4 h-6 w-6 text-white" }, void 0),
            active: false,
            external: false
        });
    }
    var subMenuItems = [
        {
            title: MenuItem.ACCOUNT,
            link: Redirect.ACCOUNT,
            icon: _jsx(CogOutline, { className: "mr-4 h-6 w-6 text-white" }, void 0),
        },
        {
            title: MenuItem.BILLING,
            link: Redirect.BILLING,
            icon: _jsx(CreditCardOutline, { className: "mr-4 h-6 w-6 text-white" }, void 0),
        },
        {
            title: MenuItem.SUPPORT,
            link: Redirect.SUPPORT,
            icon: _jsx(SupportOutline, { className: "mr-4 h-6 w-6 text-white" }, void 0),
        }
    ];
    var renderMainMenuItems = function () {
        return mainMenuItems.map(function (menuItem, key) {
            if (menuItem === null || menuItem === void 0 ? void 0 : menuItem.external) {
                return (_jsxs(AppLink, __assign({ className: "text-white hover:text-white hover:bg-indigo-600 group flex items-center px-2 mr-1 py-2 mb-2 text-sm leading-6 font-medium rounded-md", onClick: function (e) { return sidebarOpenCallback(false); }, subdomain: RedirectSubdomain.MARKETPLACE, to: Redirect.ROOT }, { children: [menuItem.icon, menuItem.title] }), void 0));
            }
            return (_jsxs(Link, __assign({ to: menuItem.link, "data-key": key, onClick: function (e) { return sidebarOpenCallback(false); }, className: "".concat(menuItem.active
                    ? "bg-indigo-800 text-white"
                    : "text-white hover:text-white hover:bg-indigo-600", " group flex items-center px-2 mr-1 py-2 mb-2 text-sm leading-6 font-medium rounded-md"), "aria-current": "page" }, { children: [menuItem.icon, menuItem.title] }), key));
        });
    };
    var renderSubMenuItems = function (subMenuItems) {
        return subMenuItems.map(function (subMenuItem, key) {
            return (_jsxs(Link, __assign({ to: subMenuItem.link, onClick: function (e) { return sidebarOpenCallback(false); }, className: "group flex items-center px-2 py-2 text-base font-medium rounded-md text-indigo-100 hover:text-white hover:bg-indigo-600" }, { children: [subMenuItem.icon, subMenuItem.title] }), key));
        });
    };
    var handleLogout = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("/api/user/logout")];
                case 1:
                    res = _a.sent();
                    if (res.ok) {
                        dispatch({ type: USER_LOGOUT });
                        history.push(Redirect.ROOT);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(Transition.Root, __assign({ show: sidebarOpen, as: Fragment }, { children: _jsxs(Dialog, __assign({ as: "div", static: true, className: "fixed inset-0 flex z-40 md:hidden", open: sidebarOpen, onClose: sidebarOpenCallback }, { children: [_jsx(Transition.Child, __assign({ as: Fragment, enter: "transition-opacity ease-linear duration-300", enterFrom: "opacity-0", enterTo: "opacity-100", leave: "transition-opacity ease-linear duration-300", leaveFrom: "opacity-100", leaveTo: "opacity-0" }, { children: _jsx(Dialog.Overlay, { className: "fixed inset-0 bg-gray-600 bg-opacity-75" }, void 0) }), void 0), _jsx(Transition.Child, __assign({ as: Fragment, enter: "transition ease-in-out duration-300 transform", enterFrom: "-translate-x-full", enterTo: "translate-x-0", leave: "transition ease-in-out duration-300 transform", leaveFrom: "translate-x-0", leaveTo: "-translate-x-full" }, { children: _jsxs("div", __assign({ className: "relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-indigo-700" }, { children: [_jsx(Transition.Child, __assign({ as: Fragment, enter: "ease-in-out duration-300", enterFrom: "opacity-0", enterTo: "opacity-100", leave: "ease-in-out duration-300", leaveFrom: "opacity-100", leaveTo: "opacity-0" }, { children: _jsx("div", __assign({ className: "absolute top-0 right-0 -mr-12 pt-2" }, { children: _jsxs("button", __assign({ type: "button", className: "ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white", onClick: function () { return sidebarOpenCallback(false); } }, { children: [_jsx("span", __assign({ className: "sr-only" }, { children: "Close sidebar" }), void 0), _jsx(XIcon, { className: "h-6 w-6 text-white", "aria-hidden": "true" }, void 0)] }), void 0) }), void 0) }), void 0), _jsx("div", __assign({ className: "flex-shrink-0 flex items-center px-4" }, { children: _jsx(Link, __assign({ to: Redirect.ROOT }, { children: _jsx("img", { className: "h-10 w-auto", src: LogoLight, alt: "DomainPage.io Logo" }, void 0) }), void 0) }), void 0), _jsx("div", __assign({ className: "mt-5 flex-1 h-0 overflow-y-auto" }, { children: _jsxs("nav", __assign({ className: "mt-5 flex-shrink-0 h-full divide-y divide-indigo-800 overflow-y-auto", "aria-label": "Sidebar" }, { children: [_jsx("div", __assign({ className: "px-2 space-y-1" }, { children: renderMainMenuItems() }), void 0), _jsx("div", __assign({ className: "mt-6 pt-6" }, { children: _jsxs("div", __assign({ className: "px-2 space-y-1" }, { children: [renderSubMenuItems(subMenuItems), _jsxs("button", __assign({ onClick: function () { return handleLogout(); }, className: "w-full group flex items-center px-2 py-2 text-base font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 text-indigo-100 hover:text-white hover:bg-indigo-600" }, { children: [_jsx(LogoutOutline, { className: "mr-4 h-6 w-6 text-white" }, void 0), "Logout"] }), void 0)] }), void 0) }), void 0)] }), void 0) }), void 0)] }), void 0) }), void 0), _jsx("div", { className: "flex-shrink-0 w-14", "aria-hidden": "true" }, void 0)] }), void 0) }), void 0), _jsx("div", __assign({ className: "hidden bg-indigo-700 md:flex md:flex-shrink-0" }, { children: _jsx("div", __assign({ className: "flex flex-col w-64" }, { children: _jsxs("div", __assign({ className: "flex flex-col flex-grow pt-5 pb-4 overflow-y-auto" }, { children: [_jsx("div", __assign({ className: "flex items-center flex-shrink-0 px-4" }, { children: _jsx(Link, __assign({ to: Redirect.ROOT }, { children: _jsx("img", { className: "h-10 w-auto", src: LogoLight, alt: "DomainPage.io Logo" }, void 0) }), void 0) }), void 0), _jsx("div", __assign({ className: "mt-5 flex-1 flex flex-col" }, { children: _jsxs("nav", __assign({ className: "mt-5 flex-1 flex flex-col divide-y divide-indigo-800 overflow-y-auto", "aria-label": "Sidebar" }, { children: [_jsx("div", __assign({ className: "px-2 space-y-1 flex flex-grow" }, { children: _jsx("div", __assign({ className: "w-full" }, { children: renderMainMenuItems() }), void 0) }), void 0), _jsx("div", __assign({ className: "mt-6 pt-6" }, { children: _jsxs("div", __assign({ className: "px-2 space-y-1" }, { children: [renderSubMenuItems(subMenuItems), _jsxs("button", __assign({ onClick: function () { return handleLogout(); }, className: "w-full group flex items-center px-2 py-2 text-base font-medium focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 rounded-md text-indigo-100 hover:text-white hover:bg-indigo-600" }, { children: [_jsx(LogoutOutline, { className: "mr-4 h-6 w-6 text-white" }, void 0), "Logout"] }), void 0)] }), void 0) }), void 0)] }), void 0) }), void 0)] }), void 0) }), void 0) }), void 0)] }, void 0));
};
export default Sidebar;
